<template>
  <symbol
    id="pin-spot-full"
    viewBox="0 0 16 16"
  >
    <circle
      cx="8"
      cy="8"
      r="8"
      fill="#b72a00"
    />
    <path
      d="M5.48-4.98v.65H3.52a7.339,7.339,0,0,1-.75-.03c.02.27.03.49.03.85v3.2A9.179,9.179,0,0,1,2.74.84H3.83a8.375,8.375,0,0,1-.05-1.1V-3.43h1.7v1.95H5.04v-.73a6.989,6.989,0,0,1,.03-.77H4.14a5.5,5.5,0,0,1,.04.77V-.89a5.949,5.949,0,0,1-.04.81h.9v-.5H7.09c.35.01.58.01.68.02a7.552,7.552,0,0,1-.02-.76V-2.2a6.624,6.624,0,0,1,.03-.77H6.86a7.375,7.375,0,0,1,.03.77v.72H6.43V-3.43H8.19V-.47c0,.2-.04.23-.31.23A9.029,9.029,0,0,1,6.85-.32,3.537,3.537,0,0,1,7.08.7c.19.02.24.02.45.03h.38C8.92.73,9.19.55,9.19-.13V-3.34a6.676,6.676,0,0,1,.05-1.03,10.167,10.167,0,0,1-1.1.04H6.43v-.65H8.54a7.6,7.6,0,0,1,1.11.06V-5.96a5.8,5.8,0,0,1-1.11.06H7.81v-.73h.54a8.7,8.7,0,0,1,.98.05V-7.63a8.819,8.819,0,0,1-1,.05H7.81v-.07a4.762,4.762,0,0,1,.05-.74H6.73a3.838,3.838,0,0,1,.05.74v.07H5.19v-.07a3.654,3.654,0,0,1,.05-.74H4.11a4.859,4.859,0,0,1,.05.74v.07H3.82a8.5,8.5,0,0,1-.99-.05v.5A8.457,8.457,0,0,0,1.38-8.32l-.72.69A7.733,7.733,0,0,1,2.2-6.25l.63-.71v.38a6.856,6.856,0,0,1,.97-.05h.36v.73H3.55a6.925,6.925,0,0,1-1.06-.06v1.04a7.666,7.666,0,0,1,1.09-.06ZM5.19-5.9v-.73H6.78v.73ZM.37-5.09A8.745,8.745,0,0,1,1.91-3.71l.72-.78A8.568,8.568,0,0,0,1.1-5.81ZM1.62-3.03A8.664,8.664,0,0,1,.33-.07l.94.86A2.526,2.526,0,0,1,1.43.43,18.52,18.52,0,0,0,2.49-2.42Z"
      transform="translate(3 12)"
      fill="#fff"
    />
  </symbol>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// full.vue?f2e73952